// ======================================================================
// File Name       : EnterpriseNoHierarchyContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Col, Button } from 'react-bootstrap';
import * as utils from '../../utils';
import { getManualPasswordSettingFlag } from '../../utils/EnterPriseUtils';

import { DEFAULT_DATE_FORMAT } from '../../constants/index';

function EnterpriseNoHierarchyContainer({
  enterprise,
  isShowPreCancelBtn,
  handlePreCancelBtn,
  handleEditBtn,
  rootFlag,
}) {
  return <>
    <div>
      <div className="font-12">企業ID</div>
      <Col sm={12} className="margin-left-15 padding-top-25 padding-bottom-40">
        {enterprise.enterpriseId}
      </Col>
    </div>
    <div>
      <div className="font-12">企業名</div>
      <Col sm={12} className="margin-left-15 padding-top-25 padding-bottom-40">
        {enterprise.enterpriseName}
      </Col>
    </div>
    <div>
      <div className="font-12">企業コード</div>
      <Col sm={12} className="margin-left-15 padding-top-25 padding-bottom-40">
        {enterprise.enterpriseCd}
      </Col>
    </div>
    <div>
      <div className="font-12">利用開始日</div>
      <Col sm={12} className="margin-left-15 padding-top-25 padding-bottom-40">
        {utils.parseDateForDetail(
          enterprise.enterpriseStartDate,
          DEFAULT_DATE_FORMAT
        )}
      </Col>
    </div>
    <div>
      <div className="font-12">稼働状態</div>
      <Col sm={12} className="margin-left-15 padding-top-25 padding-bottom-40">
        {utils.getDormantStateLabel(enterprise.dormantState)}
      </Col>
    </div>
    <div className="margin-bottom-32">
      <div className="font-12">利用機能設定</div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={2} className="font-12">
          ビデオ
        </Col>
        <Col sm={10}>
          {utils.getSettingUsageLabel(
            enterprise.usageSettingInfo.usageSettingVideo
          )}
        </Col>
      </div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={2} className="font-12">
          パスワード手動変更
        </Col>
        <Col sm={10}>
          {getManualPasswordSettingFlag(enterprise.manualPasswordSettingFlag)}
        </Col>
      </div>
    </div>
    {/* STEP14.1.0 TAS-25526 START */}
    <div className="margin-bottom-32">
      <div className="font-12">契約者情報</div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={2} className="font-12">
          契約事業者名
        </Col>
        <Col sm={10}>
          {enterprise.subscriberName}
        </Col>
      </div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={2} className="font-12">
          契約事業者の担当者名
        </Col>
        <Col sm={10}>
          {enterprise.subscriberContactPersonName}
        </Col>
      </div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={2} className="font-12">
          契約事業者の電話番号
        </Col>
        <Col sm={10}>
          {enterprise.subscriberPhoneNumber}
        </Col>
      </div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={2} className="font-12">
          契約事業者のメールアドレス
        </Col>
        <Col sm={10}>
          {enterprise.subscriberEmailAddress}
        </Col>
      </div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={2} className="font-12">
          システム情報連絡先担当者名1
        </Col>
        <Col sm={10}>
          {enterprise.systemInfomationContactPersonName1}
        </Col>
      </div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={2} className="font-12">
          システム情報連絡先担当者名2
        </Col>
        <Col sm={10}>
          {enterprise.systemInfomationContactPersonName2}
        </Col>
      </div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={2} className="font-12">
          システム情報連絡先担当者名3
        </Col>
        <Col sm={10}>
          {enterprise.systemInfomationContactPersonName3}
        </Col>
      </div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={3} className="font-12">
          システム情報連絡先メールアドレス1
        </Col>
        <Col sm={9}>
          {enterprise.systemInfomationContactEmailAddress1}
        </Col>
      </div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={3} className="font-12">
          システム情報連絡先メールアドレス2
        </Col>
        <Col sm={9}>
          {enterprise.systemInfomationContactEmailAddress2}
        </Col>
      </div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={3} className="font-12">
          システム情報連絡先メールアドレス3
        </Col>
        <Col sm={9}>
          {enterprise.systemInfomationContactEmailAddress3}
        </Col>
      </div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={3} className="font-12">
          お客様ID
        </Col>
        <Col sm={9}>
          {enterprise.customerId}
        </Col>
      </div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={3} className="font-12">
          契約企業コード
        </Col>
        <Col sm={9}>
          {enterprise.contractEnterpriseCd}
        </Col>
      </div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={3} className="font-12">
          解約フラグ
        </Col>
        <Col sm={9}>
          {enterprise.enterpriseDeleteFlag}
        </Col>
      </div>
      <div className="padding-top-25 padding-bottom-40">
        <Col sm={3} className="font-12">
          解約予定日
        </Col>
        <Col sm={9}>
          {enterprise.enterpriseDeleteDate}
        </Col>
      </div>
    {/* STEP14.1.0 TAS-25526 END */}
    </div>
    {/* Step 11.2.0 START */}
    {/* Step 12.0.0 TAS-18710 START */}
    <div className="text-center">
      {(rootFlag || isShowPreCancelBtn) && <hr />}
      {rootFlag && (
        <Button variant="primary" className="btn-96 margin-right-10" onClick={handleEditBtn}>
          編集
        </Button>
      )}
      {isShowPreCancelBtn && (
        <Button className="btn-proceedEnterpriseCancel" onClick={handlePreCancelBtn}>
          解約の手続きに進む
        </Button>
      )}
    </div>
    {/* Step 12.0.0 TAS-18710 END */}
    {/* Step 11.2.0 END */}
  </>;
}

export default EnterpriseNoHierarchyContainer;
